import React from 'react'
import { Box, Toolbar, Typography, Button } from '@mui/material'
import { useSelector } from 'react-redux'

import { selectTotalQuantity } from '../../redux/cartSlice'
import { marginX } from '../../constants'
import { useNavigate } from 'react-router-dom'
import { path } from '~/routes/path'
import { useTranslation } from 'react-i18next'

import { variantStyles } from '~/theme/constants'
import { selectRestaurant } from '~/redux/restaurantSlice'

export default function MyCartBar() {
  const currentTotalQuantity = useSelector(selectTotalQuantity)
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { food_court_id } = useSelector(selectRestaurant)

  const goToYourCart = () => {
    navigate(path.yourCart)
  }

  const renderCart = () => {
    return (
      <>
        <Typography
          onClick={goToYourCart}
          variant="h5"
          component="h5"
          color="baseColor.colorText1"
          sx={styles.myCartText}>
          {t('label.my_cart')}
        </Typography>

        <Typography
          bgcolor="baseColor.colorText1"
          color="baseColor.colorText2"
          style={styles.quantity}>
          {currentTotalQuantity}
        </Typography>
      </>
    )
  }

  const gotoOrderingScreen = () => {
    if (food_court_id) {
      navigate(path.orderingFoodCourt)
    } else {
      navigate(path.ordering)
    }
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Toolbar sx={styles.toolbar}>
        <Box sx={styles.boxMyCart}>{renderCart()}</Box>
        <Box flex={1} marginLeft="30px">
          <Button
            disabled={currentTotalQuantity === 0}
            variant={variantStyles.btnOrder}
            sx={styles.btnOrder}
            onClick={gotoOrderingScreen}>
            {t('actions.confirmOrder')}
          </Button>
        </Box>
      </Toolbar>
    </Box>
  )
}

const styles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: `0 ${marginX}px`,
  },
  boxMyCart: {
    display: 'flex',
    alignItems: 'center',
  },

  myCartText: {
    fontWeight: 700,
    textDecoration: 'underline',
    fontSize: '2.2rem',
    lineHeight: '2.7rem',
    paddingRight: '12px',
  },
  quantity: {
    borderRadius: '5px',
    fontSize: '2rem',
    fontWeight: 600,
    padding: '2px 10px',
  },
  btnOrder: {
    fontSize: '2rem',
    width: '100%',
  },
}
